






























import { Component, Vue, Prop } from 'vue-property-decorator';

type ListItem = {
  label: string;
  value: string;
}[];

@Component({
  model: {
    prop: 'selected',
    event: 'change'
  }
})
export default class PresentationFilterMenu extends Vue {
  @Prop({ type: String, required: true }) label!: string;
  @Prop({ type: Array }) selected!: string[];
  @Prop({ type: Array, required: true }) items!: ListItem[];

  select(item: string) {
    this.$emit(
      'change',
      this.selected.includes(item) ? this.selected.filter(i => i !== item) : [...this.selected, item]
    );
  }
}
